// removed by extract-text-webpack-plugin
module.exports = {"homepage-plan-display":"_1vv_M","planWrapper":"_3Y9EJ","planList":"_2l2Gu","carouselButton":"_2c843"};


//////////////////
// WEBPACK FOOTER
// ./components/PlanDisplay/styles.scss
// module id = 736
// module chunks = 0